import iconTemplate from '~/components/icons/IconTemplate.jsx';

export default iconTemplate(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 14 14"
        id="Triangle-Arrow-Merge-Vertical--Streamline-Flex"
    >
        <desc>
            {
                'Triangle Arrow Merge Vertical Streamline Icon: https://streamlinehq.com'
            }
        </desc>
        <g id="triangle-arrow-merge-vertical--up-merge-arrow-diagram">
            <path
                id="Vector"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M11 13.0017c-1.06087 0 -2.07828 -0.4214 -2.82843 -1.1716C7.42143 11.08 7 10.0626 7 9.00171 7 10.0626 6.57857 11.08 5.82843 11.8301 5.07828 12.5803 4.06087 13.0017 3 13.0017"
                strokeWidth={1}
            />
            <path
                id="Vector_2"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m7 9.00171 0 -3.65967"
                strokeWidth={1}
            />
            <path
                id="Vector 2593"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4.05437 3.94676c0.6581 -1.12132 1.7162 -2.09922 2.47416 -2.64308 0.28356 -0.20346 0.65918 -0.20346 0.94273 0 0.75797 0.54386 1.81606 1.52176 2.47416 2.64308 0.26838 0.45722 0.01706 1.00564 -0.49953 1.1248 -0.61599 0.14209 -1.46398 0.27048 -2.44599 0.27048 -0.98202 0 -1.83001 -0.12839 -2.446 -0.27048 -0.51659 -0.11916 -0.76788 -0.66758 -0.49953 -1.1248Z"
                strokeWidth={1}
            />
        </g>
    </svg>,
);
